import { required } from 'shared/utils/validators';

export const constraints = {
  quantity: [required()],
};

export interface FormData {
  quantity: string;
}
